import { useQuery } from '@tanstack/react-query';
import { get_automation_url } from '@/utils/urls';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AUTOMATION_KEY } from '@/utils/queryKeys.ts';
import { Automation } from '@/types/automations.ts';

const useRetrieveAutomation = (automationId?: string) => {
  const apiClient = useApiClient();
  const automationIdFromURL = useAutomationId();

  const currentAutomationId = automationId || automationIdFromURL;

  return useQuery<Automation, AxiosError>({
    queryKey: AUTOMATION_KEY(currentAutomationId),
    queryFn: async () => {
      const response = await apiClient.get(get_automation_url(currentAutomationId));
      return response.data;
    },
    enabled: !!currentAutomationId,
  });
};

export default useRetrieveAutomation;
